import * as React from 'react';
import Text from 'antd/lib/typography/Text';
import Space from 'antd/lib/space';
import { WarningFilled } from '@ant-design/icons';
import { runwayColors } from '../styles/globalStyles';

const AmazonAppStoreReleaseSettingsDescriptions: React.FC = () => {
    return (
        <Space>
            <WarningFilled style={{ color: runwayColors.statusYellow }} />
            <Text type="warning">Changes to the Amazon Appstore default settings are not currently supported.</Text>
        </Space>
    );
};

export default AmazonAppStoreReleaseSettingsDescriptions;
